import React from 'react';

import { Inline } from '@atlaskit/primitives/compiled/inline';

import { useSuggestionsSource } from '../useSuggestionsSource.ts';

import { SuggestionsFilterMenu } from './SuggestionsFilterMenu.tsx';
import { SuggestionsHeaderActions } from './SuggestionsHeader.tsx';

/**
 * The panel header renders its right-aligned element before the close button, so the filter menu
 * listed last here sits between the more menu and close.
 */
export const SuggestionsHeaderActionGroup = (): React.JSX.Element | null => {
	const { mode } = useSuggestionsSource();

	if (mode === 'published') {
		return null;
	}

	return (
		<Inline alignBlock="center" space="space.050">
			<SuggestionsHeaderActions />
			<SuggestionsFilterMenu />
		</Inline>
	);
};
